module.exports = __webpack_public_path__ + "img/404-not-found.84eab86.jpg";